import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useParams } from 'react-router';

import { usePixelsByIds } from '@/api/pixel';
import PixelDetailErrorOrChildren from '@/app/pixels/[pixels]/PixelDetailErrorOrChildren';
import PixelTagList from '@/app/pixels/[pixels]/PixelTagList';
import { Page, PageDateRangeFilter, PageFilterProvider } from '@/components/page';
import { PendoPlaceholder } from '@/components/PendoPlaceholder';
import { ReturnToLink } from '@/components/ReturnToLink';
import { exampleAIQuestions } from '@/constants/exampleAIQuestions';
import { PIXEL_COMPARE_MAX_LIMIT, PIXEL_COMPARE_MIN_LIMIT } from '@/constants/numbers';
import { ROUTES } from '@/router';

import PixelMultiCostPerVisitChart from './PixelMultiCostPerVisitChart';
import PixelMultiKPIMetrics from './PixelMultiKPIMetrics';
import PixelMultiOpportunityInfluenceChart from './PixelMultiOpportunityInfluenceChart';
import PixelMultiReachEngagementChart from './PixelMultiReachEngagementChart';
import PixelMultiTargetingEfficiencyChart from './PixelMultiTargetingEfficiencyChart';

const PixelCompare = () => {
  const { pixels: pixelIdString } = useParams();
  const pixelIds = pixelIdString?.split(',');
  const maxLimitExceeded = (pixelIds?.length ?? 0) > PIXEL_COMPARE_MAX_LIMIT;
  const { pixels } = usePixelsByIds(maxLimitExceeded ? undefined : pixelIds);

  return (
    <Page title={t`Pixel Compare`} exampleAIQuestions={exampleAIQuestions('pixel')}>
      <div className="flex w-full flex-col gap-6">
        <PageFilterProvider>
          <div className="flex items-start justify-between gap-8">
            <ReturnToLink route={ROUTES.pixels.path} routeName={<Trans>Pixel Overview</Trans>} />
            <PixelTagList pixels={pixels} />
          </div>
          <PixelDetailErrorOrChildren
            pixelIds={pixelIds}
            minLimit={PIXEL_COMPARE_MIN_LIMIT}
            maxLimit={PIXEL_COMPARE_MAX_LIMIT}
          >
            <div className="flex items-start justify-between">
              <PageDateRangeFilter />
              <PendoPlaceholder />
            </div>
            <PixelMultiKPIMetrics pixelIds={pixelIds} />
            <PixelMultiReachEngagementChart pixelIds={pixelIds} />
            <PixelMultiOpportunityInfluenceChart pixelIds={pixelIds} pixels={pixels} />
            <PixelMultiTargetingEfficiencyChart pixelIds={pixelIds} />
            <PixelMultiCostPerVisitChart pixelIds={pixelIds} />
          </PixelDetailErrorOrChildren>
        </PageFilterProvider>
      </div>
    </Page>
  );
};

export default PixelCompare;
